
<style scoped>
    .news,.news-top{position:relative}
    .news{width:100%;height:auto;margin-bottom:-20vw;}
    .news-top{width:100vw;height:38.8541666667vw}
    .news,.news-top{position:relative}
    .news-top-bg{width:100%;height:100%}
    .news-content{position:relative;top:-25vw;width:100%;z-index:1}
    .news-content-tabs{width:100%;padding-left:6.1458333333vw;padding-top:.9375vw;padding-bottom:2.96875vw;font-family:SourceHanSansSC;font-weight:400;font-size:1.9442708333vw;color:rgba(26,26,26,.5882352941);letter-spacing:0;line-height:2.9166666667vw}
    .news-content-tabs .tab{padding-right:6.9270833333vw;cursor:pointer;position:relative;transition:color .3s ease}
    .news-content-tabs .tab.active{color:#1a1a1a;font-weight:700}
    .news-content-list{width:100%;display:grid;padding:0 4.4270833333vw;grid-gap:4.4270833333vw;gap:4.4270833333vw;grid-template-columns:repeat(4,1fr);box-sizing:border-box;margin-bottom:40px}
    .news-content:after{content:"";position:absolute;top:0;left:0;width:100%;height:100%;background-image:linear-gradient(180deg,hsla(0,0%,100%,.85) 82%,#f5f6f7);border-radius:2.2223958333vw 2.2223958333vw 0 0;-webkit-backdrop-filter:blur(1.3541666667vw);backdrop-filter:blur(1.3541666667vw);z-index:-1}
    .news-content-list .news-item{width:19.4791666667vw;height:22.6041666667vw;background:#fff;box-shadow:0 .1390625vw 1.6666666667vw 0 hsla(0,0%,66.7%,.1294117647);border-radius:.5557291667vw;display:flex;flex-direction:column;justify-content:flex-start;position:relative;cursor:pointer;overflow:hidden}
    .news-content-list .news-item .img-box{width:100%;height:11.1458333333vw;overflow:hidden}
    .news-content-list .news-item .img{width:100%;height:100%}
    .news-content-list .news-item .info{width:100%;text-align:center;padding:1.1458333333vw;box-sizing:border-box;font-weight:400;font-size:.9723958333vw;color:#86868c;letter-spacing:0;text-align:left;line-height:1.6666666667vw;position:relative}
    .news-content-list .news-item:hover{box-shadow:0 2.67px 32px 0 hsla(0,0%,66.7%,.5019607843)}
    .news-content-list .news-item .info .title{font-family:HarmonyOS_Sans;height:4.1666666667vw;font-size:1.3890625vw;color:#1a1a1a;letter-spacing:0;line-height:2.0833333333vw}
    .news-content-list .news-item .info .subtitle{text-align:left;word-break:break-all;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;margin:1.1458333333vw 0}
    .news-content-list .news-item .info .more{width:100%;font-family:PingFang;font-size:.9026041667vw;color:#db2017;font-weight:500;text-align:center;visibility:hidden}
    .news-content-tabs .tab.active:after {content: "";position: absolute;bottom: -.625vw;left: 2.5vw;height: .3125vw;width: 2.7776041667vw;background-color: #1a1a1a;}
    .pagination{display: flex;justify-content: center;align-items: center;}
    .pagination button{border: none;background: #18cd82;border-radius: 5px;padding: 5px 12px;color: #fff;cursor: pointer;font-size: 14px;}
    .pagination button:disabled{background: #ccc;cursor: not-allowed;}
    .pagination span{margin:0 5px}

    @media screen and (max-width: 1024px){
      .news{height:100%;margin-bottom:0px}
      .news-content{top:-5vw}
      .news-content-list{grid-template-columns:repeat(2,1fr);gap:2.5vw}
      .news-content-list .news-item{width:100%;height:31vw}
      .news-content-list .news-item .img-box{height:24vw}
      .news-content-tabs{font-size:12px;padding-left:0px}
      .news-content-list .news-item .info .title{font-size:14px;}
      .news-content-list .news-item .info .subtitle{display:none;}
      .news-content-list .news-item .info .more{display:none;}
      

    }
</style>
<template>
  <div class="news page">
      <div class="news-top">
          <img src="/img/news-bg.d2f3534.png" class="news-top-bg">
      </div>
      <div class="news-content">
          <div class="news-content-tabs">
              <span class="tab" v-for="(cat, idx) in categories" :key="cat.id" :class="{ active: activeIndex === idx }" @click="changeCategory(idx, cat)">
                  {{ cat.name }}
              </span>
            </div>  
          <div class="news-content-list">
              <div class="news-item" v-for="(item, idx) in list" :key="item.id || idx" @click="goDetail(item.id)">
                  <div class="img-box">
                      <img :src="BASE_URL +item.ico" :alt="item.title" class="img">
                  </div>
                  <div class="info">
                      <div class="title">{{ item.title.slice(0, 20) }}</div>
                      <div class="subtitle">{{ item.description.slice(0, 23) }}</div>
                      <div :class="'more more' + idx" style="visibility: hidden;">Tìm hiểu thêm &gt;</div>
                  </div>
              </div>
          </div>
          <div class="pagination">
          <button @click="handlePageChange(page - 1)" :disabled="page <= 1">Trước</button>
          <span>Trang {{ page }}</span>
          <button @click="handlePageChange(page + 1)" :disabled="page * pageSize >= total">Sau</button>
        </div>
      </div>
  </div>
</template>

<script>
import { BASE_URL } from '@/config';
import axios from 'axios'; // 引入 axios
export default {
  name: 'HelloWorld',
  props: {
    msg: String
  },
  data() {
    return {
      categories: [],
      activeIndex: 0,
      list: [],
      BASE_URL,
      page: 1,
      pageSize: 12,
      total: 0
    };
  },
  
    mounted() {
    // 获取分类
    axios.get(`${BASE_URL}/index/index/category?lang=vn`, {
        params: {
            id: 2 
        }
        }).then(res => {
            if (res.data && Array.isArray(res.data.categories)) {
            this.categories = res.data.categories;
            if (this.categories.length > 0) {
            this.changeCategory(0, this.categories[0]);
            }
      }
    });
    // 菜单高亮
    const path = window.location.pathname;
    const menu = document.querySelector('.menu');
    if (menu) {
      const menuItems = menu.querySelectorAll('.menu-item');
      menuItems.forEach(item => {
        const linkDiv = item.querySelector('.menu-item-link');
        const aTag = linkDiv ? linkDiv.querySelector('a') : null;
        if (linkDiv && aTag) {
          if (aTag.getAttribute('href') === path) {
            linkDiv.classList.add('active-route');
          } else {
            linkDiv.classList.remove('active-route');
          }
        }
      });
    }
  },
  methods: {
  changeCategory(idx, cat) {
    this.activeIndex = idx;
    this.page = 1; // 切换分类时重置为第一页
    this.fetchNews(cat.id);
  },
  fetchNews(categoryId) {
    axios.get(`${BASE_URL}/index/index/newslist?lang=vn`, {
      params: {
        model: 2,
        categoryId,
        page: this.page,
        pageSize: this.pageSize
      }
    }).then(res => {
      if (res.data && Array.isArray(res.data.news)) {
        this.list = res.data.news;
        this.total = res.data.total || 0; // 假设后端返回总条数
      } else {
        this.list = [];
        this.total = 0;
      }
      // 绑定hover事件控制more按钮显示
      this.$nextTick(() => {
        const itemList = document.querySelectorAll('.news-item');
        itemList.forEach(item => {
          const more = item.querySelector('.more');
          if (more) {
            more.style.visibility = 'hidden';
            item.addEventListener('mouseenter', () => {
              more.style.visibility = 'visible';
            });
            item.addEventListener('mouseleave', () => {
              more.style.visibility = 'hidden';
            });
          }
        });
      });
    });
  },
  // 翻页
  handlePageChange(newPage) {
    this.page = newPage;
    const cat = this.categories[this.activeIndex];
    if (cat) {
      this.fetchNews(cat.id);
    }
  },
  goDetail(id) {
    this.$router.push(`/detail/${id}`);
  }
}

  
}
</script>
